import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import sun from '../../assets/img/sun.svg';
import balonsLeft from '../../assets/img/balons-left.svg';
import balonsRight from '../../assets/img/balons-right.svg';
import confetti from '../../assets/img/confeti.svg';

interface ModalProps {
  setIsCompleted: (arg: boolean) => void;
}

const CongratulationsModal = ({ setIsCompleted }: ModalProps) => {
  const { t } = useTranslation();

  return (
    <div className="modalC">
      <div className="modal-contentC">
        <div className="leftBallon">
          <img src={balonsLeft} alt="left" style={{ height: 600, width: 300 }} />
        </div>

        <div className="contentWrap">
          <div className="confetti">
            <img src={confetti} alt="confetti" style={{ height: 600, width: 500 }} />
          </div>

          <div className="sun">
            <img src={sun} alt="sun" style={{ height: 200, width: 200 }} />
          </div>
          <h1 className="congrats_title">{t('congratulations')}</h1>
          <p className="congrats_description">{t('completedTasksMessage')}</p>

          <button onClick={() => setIsCompleted(false)} className="close-modal">
            {t('close')}
          </button>
        </div>

        <div className="rightBallon">
          <img src={balonsRight} alt="balonsRight" style={{ height: 600, width: 300 }} />
        </div>
      </div>
    </div>
  );
};

export default CongratulationsModal;
